import { useMemo, useState } from 'react';
import { downloadAction } from '../../DownloadCommon/download-page';
import moment from 'moment';
import { getFeedsCommentsToGPTReport } from '@/pages/opinion/services';
import {
  notificationError,
  notificationSuccess,
} from '@/pages/opinion/pages/report/gpt/constant';
import { useIntl } from 'umi';
import { v4 as uuidv4 } from 'uuid';

export function useFeedsAigcCard({ wholeGameInfo, gameInfo }: any) {
  const { formatMessage } = useIntl();
  const [showAigcCard, setShowAigcCard] = useState(false);
  const handleAigcConfirm = (data: any, params: any) => {
    setAigcConfig(data);
    const downLoadParams = {
      ...gameInfo,
      ...params,
    };

    if (data.resultType === 'page') {
      setShowAigcCard(true);
    } else if (data.resultType === 'download') {
      setShowAigcCard(false);
      downLoadParams.prompt = data.prompt;
      const gameName = wholeGameInfo?.entity_name || '';
      const fileName = `Opinions_${gameName}_GPT_${
        downLoadParams.review_type === 'all' ? 'Post&Comments' : 'Post'
      }_${moment(downLoadParams.start_time).format('YYYYMMDD')}_${moment(
        downLoadParams.end_time,
      ).format('YYYYMMDD')}`;
      downloadAction({
        fileName,
        downLoadParams,
        sheetName: 'AIGC',
        downloadFunc: 'getOpinionFeedsCommentsInfoDownload',
      });
    } else {
      // GPT 报告
      downLoadParams.emails = data.emailList;
      // 发送请求
      getFeedsCommentsToGPTReport(downLoadParams)
        .then(() => {
          notificationSuccess(
            formatMessage({ id: 'Subscription successful.' }),
          );
        })
        .catch(() => {
          notificationError(formatMessage({ id: 'Subscription failure' }));
        });
    }
  };
  const [aigcConfig, setAigcConfig] = useState({ prompt: '', resultType: '' });

  const aigcCardId = useMemo(() => {
    return uuidv4();
  }, [aigcConfig]);

  return {
    showAigcCard,
    handleAigcConfirm,
    aigcCardId,
    aigcConfig,
    setShowAigcCard,
  };
}
